var SummaryView = Backbone.View.extend({
  render: function(data) {
    this.$el.html(this.template(data)).show();
    this.isInitialized = true;
  },

  hideView: function() {
    this.$el.hide();
  },

  initialize: function() {
    this.isInitialized = false;
    this.template = Handlebars.compile(
      this.$("[data-summary-template]").length
        ? this.$("[data-summary-template]").html()
        : ""
    );

    // using 5 as a fallback while loading
    this.render({ total_count: 0 });
  }
});

module.exports = SummaryView;
